'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOffers = exports.triggerBonusByPromoCode = exports.preclaimBonus = exports.cancelBonus = exports.rejectBonus = exports.claimBonus = exports.getPendingBonuses = exports.getMonetaryBonuses = exports.getFreeSpins = exports.getBonusById = exports.getBonuses = undefined;

var _bonus = require('tg-core-api/lib/bonus');

var _bonus2 = _interopRequireDefault(_bonus);

var _bonusFt = require('tg-core-api/lib/bonus-ft');

var _bonusFt2 = _interopRequireDefault(_bonusFt);

var _action = require('../../lib/action');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getProvider = function getProvider(provider) {
  if (provider === 'fasttrack') return _bonusFt2.default;
  return _bonus2.default;
};

var getBonuses = exports.getBonuses = function getBonuses(playerSessionID, provider) {
  return (0, _action.makeApiCallAction)('GET_BONUSES', getProvider(provider).getBonuses(playerSessionID));
};

var getBonusById = exports.getBonusById = function getBonusById(playerSessionID, bonusID, provider) {
  return (0, _action.makeApiCallAction)('GET_BONUS_BY_ID', getProvider(provider).getBonusById(playerSessionID, bonusID));
};
var getFreeSpins = exports.getFreeSpins = function getFreeSpins(playerSessionID, provider) {
  return (0, _action.makeApiCallAction)('GET_FREE_SPINS', getProvider(provider).getFreeSpins(playerSessionID));
};
var getMonetaryBonuses = exports.getMonetaryBonuses = function getMonetaryBonuses(playerSessionID, provider) {
  return (0, _action.makeApiCallAction)('GET_MONETARY_BONUSES', getProvider(provider).getMonetaryBonuses(playerSessionID));
};
var getPendingBonuses = exports.getPendingBonuses = function getPendingBonuses(playerSessionID, provider) {
  return (0, _action.makeApiCallAction)('GET_PENDING_BONUSES', getProvider(provider).getPendingBonuses(playerSessionID));
};
var claimBonus = exports.claimBonus = function claimBonus(playerSessionID, bonusID, provider) {
  return (0, _action.makeApiCallAction)('CLAIM_BONUS', getProvider(provider).claimBonus(playerSessionID, bonusID));
};
var rejectBonus = exports.rejectBonus = function rejectBonus(playerSessionID, bonusID, provider) {
  return (0, _action.makeApiCallAction)('REJECT_BONUS', getProvider(provider).rejectBonus(playerSessionID, bonusID));
};
var cancelBonus = exports.cancelBonus = function cancelBonus(playerSessionID, bonusID, provider) {
  return (0, _action.makeApiCallAction)('CANCEL_BONUS', getProvider(provider).cancelBonus(playerSessionID, bonusID));
};
var preclaimBonus = exports.preclaimBonus = function preclaimBonus(playerSessionID, promotionCode, provider) {
  return (0, _action.makeApiCallAction)('PRECLAIM_BONUS', getProvider(provider).preclaimBonus(playerSessionID, promotionCode));
};
var triggerBonusByPromoCode = exports.triggerBonusByPromoCode = function triggerBonusByPromoCode(playerSessionID, promotionCode, provider) {
  return (0, _action.makeApiCallAction)('TRIGGER_BONUS_BY_PROMO_CODE', getProvider(provider).triggerBonusByPromoCode(playerSessionID, promotionCode));
};
var getOffers = exports.getOffers = function getOffers(playerSessionID, provider) {
  return (0, _action.makeApiCallAction)('GET_OFFERS', getProvider(provider).getOffers(playerSessionID));
};

exports.default = {
  getBonuses: getBonuses,
  getBonusById: getBonusById,
  getFreeSpins: getFreeSpins,
  getMonetaryBonuses: getMonetaryBonuses,
  getPendingBonuses: getPendingBonuses,
  claimBonus: claimBonus,
  rejectBonus: rejectBonus,
  cancelBonus: cancelBonus,
  preclaimBonus: preclaimBonus,
  triggerBonusByPromoCode: triggerBonusByPromoCode,
  getOffers: getOffers
};